import React from 'react';
import { Provider } from 'react-redux'
import { store } from './store/store'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import RoutesDesktop from './Routes.desktop'
import RoutesMobile from './Routes.mobile'
import Navigation from './view/mobile/navigation'
import { Loading, Notify, Alert } from './view/components'
import 'bootstrap/dist/css/bootstrap.min.css'
import './global.css'
import Feedback from './view/components/feedback';
import InitTheme from './view/components/theme';
import TwoFaVerify from './view/auth/2fa-verify';

const theme = createTheme({
    palette: {
        primary: {
            main: '#007bff'
        },
    },
    typography: {
        fontFamily: 'Inter, sans-serif',
    },
    props: {
        MuiTextField: {
            variant: 'outlined',
            fullWidth: true
        },
        MuiSelect: {
            variant: 'outlined',
            fullWidth: true
        }
    }
});

const App = () => {
    const [ mobile, setMobile ] = React.useState(window.innerWidth < 577 ? true : false)

    React.useEffect(() => {
        let theme = localStorage.getItem('data-bs-theme')

        if(!theme) {
            localStorage.setItem('data-bs-theme', 'dark')
        }

        const bs_theme = localStorage.getItem('data-bs-theme')
        if(bs_theme) {
            document.documentElement.setAttribute('data-bs-theme', bs_theme)
            
            const metaTag = document.querySelector('meta[name="theme-color"]')

            if (metaTag) {
                metaTag.setAttribute('content', '#1f2a37')
            }else {
                const meta = document.createElement('meta')
                meta.name = 'theme-color'
                meta.content = '#1f2a37'
                document.head.appendChild(meta)
            }
        }
        window.addEventListener('resize', _resize)
        window.addEventListener('storage', _storage)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _resize = () => {
        setMobile(window.innerWidth < 577 ? true : false)
    }

    const _storage = (e) => {
        if(e.key === 'data-bs-theme') {
            document.documentElement.setAttribute('data-bs-theme', e.newValue)
        }
    }
    
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <InitTheme />
                <Feedback />
                <Alert />
                <Notify />
                <Loading />
                <Navigation mobile={mobile} />
                {(mobile) ? <RoutesMobile /> : <RoutesDesktop />}
                <TwoFaVerify />
            </ThemeProvider>
        </Provider>
    )
}

export default App;
